import * as React from 'react';
import { Empty, Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { listReports } from './api';
import { PLATFORM_LABEL } from './types';

export const HISTORY_QUERY_KEY = ['social-metrics-reports'];

const HistoryTable: React.FC<{ activeId?: number }> = ({ activeId }) => {
    const navigate = useNavigate();
    const { data = [], isLoading } = useQuery({
        queryKey: HISTORY_QUERY_KEY,
        queryFn: listReports,
    });

    return (
        <div style={{ marginTop: 32 }}>
            <Typography.Title level={4}>History</Typography.Title>
            <Typography.Paragraph type="secondary" style={{ marginTop: -8 }}>
                The latest 100 reports. Creating another deletes the oldest.
            </Typography.Paragraph>
            <Table
                rowKey="id"
                loading={isLoading}
                dataSource={data}
                pagination={false}
                locale={{ emptyText: <Empty description="No reports yet" /> }}
                rowClassName={(row) => (row.id === activeId ? 'ant-table-row-selected' : '')}
                onRow={(row) => ({
                    onClick: () => navigate(`/reporting/social-metrics/${row.id}`),
                    style: { cursor: 'pointer' },
                })}
                columns={[
                    {
                        title: 'Platform',
                        dataIndex: 'platform',
                        render: (v: string) => PLATFORM_LABEL[v] || v,
                    },
                    {
                        title: 'Account',
                        render: (_, row) => row.display_name || row.account_input,
                    },
                    { title: 'Period', dataIndex: 'period_label' },
                    { title: 'Created by', dataIndex: 'created_by', render: (v: string) => v || '—' },
                    {
                        title: 'Created',
                        dataIndex: 'created_at',
                        render: (v: string) => (v ? new Date(v).toLocaleString() : '—'),
                    },
                ]}
            />
        </div>
    );
};

export default HistoryTable;
